import { ILastMinute } from '../Client/ILastMinute'

export const GET_LAST_MINUTES = 'GET_LAST_MINUTES'
export const GET_LAST_MINUTES_SUCCESS = 'GET_LAST_MINUTES_SUCCESS'
export const GET_LAST_MINUTES_FAILURE = 'GET_LAST_MINUTES_FAILURE'

export const DELETE_LAST_MINUTE = 'DELETE_LAST_MINUTE'
export const DELETE_LAST_MINUTE_SUCCESS = 'DELETE_LAST_MINUTE_SUCCESS'
export const DELETE_LAST_MINUTE_FAILURE = 'DELETE_LAST_MINUTE_FAILURE'

export const DELETE_LAST_MINUTE_PERMANENT = 'DELETE_LAST_MINUTE_PERMANENT'
export const DELETE_LAST_MINUTE_PERMANENT_SUCCESS =
    'DELETE_LAST_MINUTE_PERMANENT_SUCCESS'

export const UNDO_DELETE_LAST_MINUTE = 'UNDO_DELETE_LAST_MINUTES'
export const UNDO_DELETE_LAST_MINUTE_SUCCESS =
    'UNDO_DELETE_LAST_MINUTES_SUCCESS'
export const UNDO_DELETE_LAST_MINUTE_FAILURE =
    'UNDO_DELETE_LAST_MINUTES_FAILURE'

interface GetLastMinutesAction {
    type: typeof GET_LAST_MINUTES
}

interface GetLastMinutesSuccessAction {
    type: typeof GET_LAST_MINUTES_SUCCESS
    payload: {
        lastMinutes: ILastMinute[]
    }
}

interface GetLastMinutesFailureAction {
    type: typeof GET_LAST_MINUTES_FAILURE
}

interface DeleteLastMinuteAction {
    type: typeof DELETE_LAST_MINUTE
}

interface DeleteLastMinuteSuccessAction {
    type: typeof DELETE_LAST_MINUTE_SUCCESS
    payload: {
        lastMinute: ILastMinute
    }
}

interface DeleteLastMinutePermanentAction {
    type: typeof DELETE_LAST_MINUTE_PERMANENT
    payload: {
        lastMinute: ILastMinute
    }
}

interface DeleteLastMinuteFailureAction {
    type: typeof DELETE_LAST_MINUTE_FAILURE
}

interface UndoDeleteLastMinuteAction {
    type: typeof UNDO_DELETE_LAST_MINUTE
}

interface UndoDeleteLastMinuteSuccessAction {
    type: typeof UNDO_DELETE_LAST_MINUTE_SUCCESS
    payload: {
        lastMinute: ILastMinute
    }
}

interface UndoDeleteLastMinuteFailureAction {
    type: typeof UNDO_DELETE_LAST_MINUTE_FAILURE
}

export type ActionTypes =
    | GetLastMinutesAction
    | GetLastMinutesSuccessAction
    | GetLastMinutesFailureAction
    | DeleteLastMinuteAction
    | DeleteLastMinuteSuccessAction
    | DeleteLastMinuteFailureAction
    | DeleteLastMinutePermanentAction
    | UndoDeleteLastMinuteAction
    | UndoDeleteLastMinuteSuccessAction
    | UndoDeleteLastMinuteFailureAction
